import React, {
  useContext,
} from 'react';
import styled from "styled-components";

import PulseLoader from "react-spinners/PulseLoader";
import BounceLoader from "react-spinners/BounceLoader";

import { ThemeContext } from '@dstantwo/ullr-react-components';

const LoadingIndicatorContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.backgroundColor || useContext(ThemeContext).COLORS.TRANSPARENT};

  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoadingIndicatorContainerAbsolute = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.backgroundColor || useContext(ThemeContext).COLORS.TRANSPARENT};

  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export default function UllrLoadingIndicator(props) {
  const { COLORS } = useContext(ThemeContext);
  const Container = props.absolute ? LoadingIndicatorContainerAbsolute : LoadingIndicatorContainer;

  return (
    <Container>
      <PulseLoader color={COLORS.SECONDARY} loading={true} size={21} margin={2} />
    </Container>
  );
}

export const UllrCircularLoader = (props) => {
  const { COLORS } = useContext(ThemeContext);
  return (
    <BounceLoader color={COLORS.SECONDARY} loading={true} size={props.size || 21} margin={2} />
  );
};